import { render, staticRenderFns } from "./index-news.vue?vue&type=template&id=74569d05&scoped=true"
import script from "./index-news.vue?vue&type=script&lang=js"
export * from "./index-news.vue?vue&type=script&lang=js"
import style0 from "./index-news.vue?vue&type=style&index=0&id=74569d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74569d05",
  null
  
)

export default component.exports